import React from "react";
import ReactECharts from "echarts-for-react";

const StackedBarChart = ({ data }) => {
  const colors = [
    "#C3F2FA",
    "#C3CFFA",
    "#C3E0FA",
    "#89FAE6",
    "#708BA2",
    "#FEF2E8",
    "#CAF5C6",
  ]; 

  const processDataForECharts = (apiResponse) => {
    const users = [];
    const trackSet = new Set();
    const userTrackData = {};

    apiResponse.forEach((userObj) => {
      const userName = Object.keys(userObj)[0];
      users.push(userName);

      const userData = userObj[userName];

      Object.keys(userData).forEach((track) => {
        trackSet.add(track);

        if (!userTrackData[userName]) {
          userTrackData[userName] = {};
        }

        userTrackData[userName][track] = userData[track];
      });
    });

    const tracks = Array.from(trackSet);
    const series = tracks.map((track, index) => {
      return {
        name: track,
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: users.map((user) => userTrackData[user][track] || 0),
        itemStyle: {
          color: colors[index % colors.length], // Assign colors cyclically
        },
      };
    });

    return {
      users,
      tracks,
      series,
    };
  };

  const { users, tracks, series } = processDataForECharts(data);

  const option = {
    grid: {
      left: "4%",
      right: "4%",
      top: "10%",
      bottom: "20%",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: (params) => {
        const userName = params[0].axisValue;
        let tooltipContent = `<div style="font-size:14px;font-weight:bold;color:#333;">${userName}</div>`;
        params.forEach((item) => {
          const trackName = item.seriesName;
          const value = item.data;
          tooltipContent +=
            `<div style="margin:5px 0;"><span style="display:inline-block;width:12px;height:12px;border-radius:50%;background-color:${item.color};margin-right:8px;"></span>` +
            `${trackName}: ${value}</div>`;
        });
        return tooltipContent;
      },
      backgroundColor: "#f9f9f9",
      borderColor: "#ccc",
      borderWidth: 1,
      textStyle: {
        color: "#333",
      },
    },
    legend: {
      data: tracks,
      top: "5%",
      textStyle: {
        fontSize: 12,
        color: "#333",
      },
    },
    xAxis: {
      type: "category",
      data: users,
      axisTick: {
        alignWithLabel: true,
        inside: true,
      },
      axisLabel: {
        fontSize: 10,
        color: "#555",
      },
    },
    dataZoom: [
      {
        type: "slider",
        xAxisIndex: 0,
        zoomLock: true,
        moveOnMouseMove: false,
        showDetail: false,
        showDataShadow: true,
        realtime: true,
        brushSelect: false,
        start: 0,
        end: 50,
        bottom: "10px",
        handleSize: "100%",
        handleStyle: {
          color: "#85D7FF",
          borderWidth: 1,
          borderColor: "#5AB1F6",
        },
        fillerColor: "rgba(133, 215, 255, 0.2)",
        borderColor: "transparent",
        textStyle: {
          color: "transparent",
        },
      },
    ],
    yAxis: {
      type: "value",
      name: "Count",
      axisLabel: {
        fontSize: 12,
        color: "#555",
      },
      nameTextStyle: {
        fontSize: 14,
        color: "#333",
      },
    },
    series: series,
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: "500px", width: "100%" }}
    />
  );
};

export default StackedBarChart;
